"use client"

import { useEffect } from "react";
import { DatePickerFilter, InputFilter, SearchFilter } from "@/theme/ui/filter/elements";
import { Form, Space, Button } from "antd";
import { CategoriesIcon } from "@/theme/assets/icons";
import { CategoryFilter } from "@/theme/ui/filter/elements/category";
import style from './style.module.scss'
import cn from "classnames/bind";
import dayjs from "dayjs";
import { useWindowSize } from "@/lib/hook";

export const Filter = ({useFilters, onChange, initialValues, displayButton, setIsShow = null, isShow = false, smallFilterSelectCount = 0}) => {
    const windowSize = useWindowSize()
    const [form] = Form.useForm();

    useEffect(()=>{
        form.setFieldsValue(defaultValueParse(initialValues))
    }, [])

    const onResetFilter = () =>{

    }

    const onFinish = (values) =>{
        if (onChange){
            onChange(transformDataResponse(values))
        }
    }

    const transformDataResponse = (values) =>{
        useFilters.forEach((item)=>{
            const name = item.name ?? getDefaultFilterName(item.type)
            switch (item.type){
                case 'date':
                    const format = item.hasOwnProperty('format') ? item.format : 'YYYY-MM-DD'

                    values = {
                        ...values,
                        [name]: values[name] ? values[name].format(format) : null
                    }
                    break;
                case 'search':
                    values = {
                        ...values,
                        [name]: values[name] ? values[name] : null
                    }
                    break;
            }
        })

        return values
    }

    const defaultValueParse = (values) =>{
        if (values){
            useFilters.forEach((item)=>{
                const name = item.name ?? getDefaultFilterName(item.type)
                switch (item.type){
                    case 'date':
                        const value = values.hasOwnProperty(name) ? values[name] : null

                        if (value){
                            values = {
                                ...values,
                                [name]: dayjs(value)
                            }
                        }
                        break
                }
            })

            return values
        }
        return {}
    }

    return (
        <>
            <Form
                form={form}
                name="search"
                autoComplete="off"
                layout={'vertical'}
                onFinish={onFinish}
            >
                <Space
                    size={12}
                    wrap
                >
                    {useFilters.map((item, key)=>{
                        const filterName = item.type

                        return getFilter(filterName, item, `${filterName}_${key}`, windowSize, displayButton, setIsShow, isShow, smallFilterSelectCount)
                    })}
                </Space>
                <Form.Item
                    hidden
                    noStyle
                >
                    <Button htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
}

const iconInout = (icon) =>{
    let iconNode = null

    switch (icon){
        case 'dollar':
            iconNode = <></>
            break
        case 'category':
            iconNode = <CategoriesIcon />
            break
        default:
            return {}
    }

    return {
        prefix: iconNode
    }
}

const getFilter = (filter, props, key, windowSize, displayButton, setIsShow, isShow, smallFilterSelectCount) =>{
    const name = props.name ?? getDefaultFilterName(filter)

    switch (filter){
        case 'search':
            return <SearchFilter {...props}
                                 name={name}
                                 key={key}
                                 display={displayButton}
                                 setIsShow={setIsShow}
                                 isShow={isShow}
                                 smallFilterSelectCount={smallFilterSelectCount}
            />
        case 'date':
            return <DatePickerFilter {...props} name={name} key={key}/>
        case 'category':
            return <CategoryFilter {...props} name={name} key={key}/>
        case 'input':
            return <InputFilter {...props} name={name} {...iconInout(props.icon)} key={key}/>
        case 'space':
            if (windowSize.width <= 768){
                return  null
            }
            return <SpaceBetween {...props} key={key}/>
        default:
            return null
    }
}

const getDefaultFilterName = (filterType) =>{
    switch (filterType){
        case 'search':
            return 'search'
        case 'date':
            return 'date'
        case 'category':
            return 'category'
        case 'input':
            return 'input'
        default:
            return '}{_}'
    }
}

const SpaceBetween = ({className, ...props}) =>{
    return(
        <>
            <div
                className={cn(style.space_between_wrapper, className)}
                {...props}
            />
        </>
    )
}